import { LoadingOutlined } from '@ant-design/icons'
import TableBase from 'components/Table/TableBase'
import { useEffect, useState } from 'react'
import { useOrderUpdateWeigh } from 'services/swr/order'
import { numberWithCommas } from 'utils'
import { Flex } from 'widgets/Box'
import { useHistory } from 'react-router-dom'
import * as qs from 'query-string'

import FilterForm from './FilterForm'

const HistoryTable = () => {
  const history = useHistory()

  const [params, setParams] = useState<any>(() => {
    const query = qs.parse(location.search)
    return {
      page: Number(query.page) || 1,
      per_page: Number(query.per_page) || 25,
      order_code: query.order_code || undefined,
    }
  })

  useEffect(() => {
    const query = qs.parse(location.search)
    setParams({
      page: Number(query.page) || 1,
      per_page: Number(query.per_page) || 25,
      order_code: query.order_code || undefined,
    })
  }, [])

  useEffect(() => {
    if (params) {
      const queryString = qs.stringify(params)
      history.push({
        pathname: history.location.pathname,
        search: queryString ? `?${queryString}` : '',
      })
    }
  }, [history, params])

  const { data, isLoading } = useOrderUpdateWeigh(params)

  const columns = [
    {
      title: 'Ngày điều chỉnh',
      dataIndex: 'created_at',
      render: (value) => value,
    },
    {
      title: 'Mã đơn',
      dataIndex: 'order_code',
      render: (value, item) => (
        <p>
          {value}
        </p>
      ),
    },
    {
      title: 'Người nhận',
      dataIndex: 'receiver',
      render: (value) => (
        <Flex flexDirection={'column'} alignItems={'flex-start'}>
          <p>{value?.full_name}</p>
          <p>{value?.phone_number}</p>
        </Flex>
      ),
    },
    {
      title: 'Trước điều chỉnh',
      dataIndex: 'from_package',
      render: (value) => (
        <Flex flexDirection={'column'} alignItems={'flex-end'}>
          <p>{value?.package_title}</p>
          <p>Khối lượng: {value?.weight}</p>
          <p>Giá vận: {numberWithCommas(value?.fee)}</p>
        </Flex>
      ),
    },
    {
      title: 'Sau điều chỉnh',
      dataIndex: 'to_package',
      render: (value) => (
        <Flex flexDirection={'column'} alignItems={'flex-end'}>
          <p>{value?.package_title}</p>
          <p>Khối lượng: {value?.weight}</p>
          <p>Giá vận: {numberWithCommas(value?.fee)}</p>
        </Flex>
      ),
    },
    {
      title: 'Thu hộ',
      dataIndex: 'cod',
      render: (value, item) => (
        <Flex flexDirection={'column'} alignItems={'flex-end'}>
          <p>{numberWithCommas(value)}</p>
          <p>Ship: {numberWithCommas(item?.fee)}</p>
        </Flex>
      ),
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status_string',
      render: (value, item) => (
        <Flex flexDirection={'column'} alignItems={'center'}>
          <p>{value}</p>
          <p style={{ color: '#018848', cursor: 'pointer' }} onClick={() => window.open(`/xem-don-hang/${item?.id}`, '_blank')}>
            Xem đơn hàng
          </p>
        </Flex>
      ),
    },
  ]

  return (
    <>
      <FilterForm setParams={setParams} params={params} loadingSearch={isLoading} />

      <TableBase
        columns={columns}
        dataSource={data?.orders}
        scroll={{ x: 1000 }}
        rowKey={(row) => row.id}
        pagination={{
          current: data?.meta?.current_page,
          pageSize: data?.meta?.per_page,
          total: data?.meta?.total,
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            if (pageSize !== data?.meta?.per_page) {
              page = 1
            }
            window.scrollTo({ top: 0, behavior: 'smooth' })
            setParams((prev) => ({
              ...prev,
              page: page,
              per_page: pageSize,
            }))
          },
          showTotal: (total) => `Tổng ${total}`,
        }}
      />
    </>
  )
}

export default HistoryTable
